module.exports = __webpack_public_path__ + "static/media/bn.c5b91605.svg";